/* BFE Origin Button — cursor-aware fill that expands from the cursor's entry point
   and collapses toward its exit point. Desktop pointers only. */
(function () {
  var mq = window.matchMedia('(min-width: 700px) and (hover: hover) and (pointer: fine)');
  if (!mq.matches) return;

  var SELECTOR = [
    '.button:not(.button--outline):not(.button--subdued)',
    '.btn',
    '.shopify-payment-button__button--unbranded',
    'a[class*="__btn"]',
    'button[class*="__btn"]'
  ].join(', ');

  function isDarkButton(btn) {
    var color = window.getComputedStyle(btn).backgroundColor.match(/[\d.]+/g);
    if (!color || color.length < 3 || Number(color[3]) === 0) return false;

    var r = Number(color[0]);
    var g = Number(color[1]);
    var b = Number(color[2]);
    var luminance = (0.2126 * r) + (0.7152 * g) + (0.0722 * b);

    return luminance < 145;
  }

  function enhance(btn) {
    if (btn.dataset.bfeOrigin) return;
    btn.dataset.bfeOrigin = '1';
    btn.classList.add('bfe-origin');

    // Keep labels and icons above the animated fill. Loader/feedback elements
    // stay as direct children so Impact's absolute positioning still works.
    var content = document.createElement('span');
    content.className = 'bfe-origin__content';

    Array.from(btn.childNodes).forEach(function (node) {
      var isSystemLayer = node.nodeType === 1 && node.matches('.button__loader, .button__feedback');
      if (!isSystemLayer) content.appendChild(node);
    });

    btn.insertBefore(content, btn.firstChild);

    var fill = document.createElement('span');
    fill.className = 'bfe-origin__fill';
    fill.setAttribute('aria-hidden', 'true');
    btn.appendChild(fill);

    function place(e) {
      var r = btn.getBoundingClientRect();
      var x = e.clientX - r.left;
      var y = e.clientY - r.top;
      // diameter = 2 * distance from the cursor to the farthest corner (so it always fills)
      var d = Math.hypot(Math.max(x, r.width - x), Math.max(y, r.height - y)) * 2;
      btn.style.setProperty('--ox', x + 'px');
      btn.style.setProperty('--oy', y + 'px');
      btn.style.setProperty('--od', d + 'px');
    }

    btn.addEventListener('mouseenter', function (e) { place(e); btn.classList.add('is-origin-hover'); });
    btn.addEventListener('mouseleave', function (e) { place(e); btn.classList.remove('is-origin-hover'); });
  }

  function enhanceCandidates(candidates) {
    // Read every candidate's original style before wrapping any button. This
    // avoids forcing style recalculation after each preceding enhancement.
    Array.from(candidates).filter(function (btn) {
      return !btn.dataset.bfeOrigin && isDarkButton(btn);
    }).forEach(enhance);
  }

  function run(root) {
    enhanceCandidates((root || document).querySelectorAll(SELECTOR));
  }

  if (document.readyState !== 'loading') run();
  else document.addEventListener('DOMContentLoaded', function () { run(); });

  // Re-scan when sections re-render in the theme editor.
  document.addEventListener('shopify:section:load', function (e) { run(e.target); });

  // Cart, quick-buy and app buttons can be injected after the initial page load.
  new MutationObserver(function (mutations) {
    var candidates = new Set();
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.matches && node.matches(SELECTOR)) candidates.add(node);
        node.querySelectorAll(SELECTOR).forEach(function (btn) { candidates.add(btn); });
      });
    });
    enhanceCandidates(candidates);
  }).observe(document.body, { childList: true, subtree: true });
})();
